import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {Card, Button, Loader, Table} from 'semantic-ui-react';
import mapKeys from 'lodash/mapKeys';
import orderBy from 'lodash/orderBy';
import './manageColors.scss';
import moment from 'moment';
import {dateFormatShow} from '../../../common/constants/datesFormat';
import ManageColorsTable from './Table';
import React from 'react';
class ManageColors extends React.Component {
  state = {
    'filtered': [],
    'columns': [
      {
        'Header': 'Código',
        'accessor': 'colorCode',
        'width': 10,
      },
      {
        'id': 'type',
        'Header': 'Tipo',
        'accessor': (cell) => {
          return cell.type === 'E' ? 'Exterior' : 'Interior';
        },
        'width': 10,
      },
      {
        'Header': 'Descripción',
        'accessor': 'colorDescription',
        'width': 40,
      },
      {
        'Header': 'Descripción Inglés',
        'accessor': 'specialDescription',
        'width': 40,
      },
      {
        'Header': 'Usuario Edición',
        'accessor': 'modificationUser',
        'width': 20,
      },
      {
        'id': 'modificationDate',
        'Header': 'Fecha Edición',
        'accessor': (cell) => {
          if (cell.modificationDate) {
            return moment(cell.modificationDate).format(dateFormatShow);
          }
          return moment(cell.creationDate).format(dateFormatShow);
        },
        'width': 20,
      },
      {
        'Header': 'Estado',
        'accessor': 'status',
        'width': 15,
        'Cell': (cell) => {
          const status = cell.row.original.status;
          return (
            <select
              className="select-colors-maintenance"
              onChange={(e) => this.onChangeSelectState(e, cell.row)}
              value={status}
            >
              {this.renderOptionState()}
            </select>
          );
        },
        'Filter': SelectColumnFilter,
      },
    ],
  };

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.ManageColors, scopes.See)) {
      this.props.push(paths.AccessDenied);
      return;
    }
    this.props.fetchColors();
  }

  renderOptionState() {
    return (
      <React.Fragment>
        <option value="A">ACTIVO</option>
        <option value="I">INACTIVO</option>
      </React.Fragment>
    );
  }

  renderAddButton() {
    const createPermission = hasAccessPermission(this.props.permissions, resources.ManageColors, scopes.Create);
    return (
      <Button
        primary
        className='toyota-primary'
        as={Link}
        to={paths.ManageColorsFormAdd}
        disabled={!createPermission}
      >
        Añadir nuevo
      </Button>
    );
  }

  onChangeSelectState = (event, row) => {
    const status = event.target && event.target.value;
    const data = {
      ...row.original,
      'status': status,
    };
    if (!hasAccessPermission(this.props.permissions, resources.ManageColors, scopes.Edit)) {
      this.props.addMessageBoxError('Petición no procesada, usuario no cuenta con el permiso de edición.');
      return;
    }
    this.props.updateManageColors(data);
  };

  renderLoader() {
    return (
      <Table striped className='toyota-grid'>
        <Table.Body>
          <Table.Row>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' content='Ejecutando' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    );
  }

  render() {
    const {columns} = this.state;
    const {loading} = this.props;
    return (
      <div>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Gestión de colores</h2>
              <div className='title-bar-actions'>
                {this.renderAddButton()}
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid className='colors-table'>
          {loading ? this.renderLoader() :
            <ManageColorsTable columnsTable={columns} />}
        </Card>
      </div>
    );
  }
}

function SelectColumnFilter({
  'column': {filterValue, setFilter, preFilteredRows, id},
}) {
  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);

  return (
    <select
      value={filterValue}
      onChange={(e) => {
        setFilter(e.target.value || null);
      }}
    >
      <option value="">TODOS</option>
      {options.map((option, i) => (
        <option key={i} value={option}>
          {option === 'A' ? 'ACTIVO' : 'INACTIVO'}
        </option>
      ))}
    </select>
  );
}


const {fetchColors, updateManageColors, addMessageBoxError, withRouter} = Actions;

const mapStateToProps = (state, ownProps) => {
  const {colors} = state.manageColors;
  return {
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    'loading': state.manageColors.loading,
    'searchColors': orderBy(mapKeys(colors, 'colorCode'), 'colorCode'),
    'colorsSortType': mapKeys(colors, 'type'),
    'showMessage': state.messageBox.showMessage,
  };
};

const mapDispatchToProps = {
  fetchColors,
  updateManageColors,
  addMessageBoxError,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ManageColors));
